var map = {
	"./M_Brilliant.mp3": "458d",
	"./M_Excellent.mp3": "2209",
	"./M_Fantastic.mp3": "a3df",
	"./M_Great.mp3": "69de",
	"./M_Perfect.mp3": "0631",
	"./M_Think again.mp3": "608c",
	"./M_Try again.mp3": "f10c",
	"./M_Very good.mp3": "9594",
	"./M_Well done.mp3": "e421",
	"./M_Work harder.mp3": "e85e",
	"./click.mp3": "0841"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba21";